import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitWaitlist = (payload) => api.post("/waitlist", payload).then((r) => r.data);

export const adminLogin = (password) => api.post("/admin/login", { password }).then((r) => r.data);

export const fetchWaitlist = (token) =>
  api
    .get("/admin/waitlist", { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);

export const fetchWaitlistStats = (token) =>
  api
    .get("/admin/waitlist/stats", { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);

export const exportWaitlistUrl = () => `${API}/admin/waitlist/export`;
